import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { __ } from "../../../../utils";
import { App, Divider } from "antd";
import { copyToClipboard } from "@devowl-wp/react-utils";
const ConsentTableRecordExport = observer((param)=>{
    let { record } = param;
    const { message } = App.useApp();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Divider, {
                children: __("Export consent")
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "description",
                children: __("Use the button below to export all consents in a machine readable form.")
            }),
            /*#__PURE__*/ _jsx("button", {
                className: "button button-large",
                onClick: ()=>{
                    copyToClipboard(JSON.stringify(record.export));
                    message.success(__("Successfully copied to the clipboard!"));
                },
                children: __("Export to clipboard")
            })
        ]
    });
});
export { ConsentTableRecordExport };
